import React from "react";
import Modal from "react-bootstrap/Modal";
import { ImCross } from "react-icons/im";
import "./PriceRangeModal.css";

const PriceRangeModal = ({ show, onHide, priceRanges, onSelectPrice }) => {

  const handlePriceSelect = (price) => {
    onSelectPrice(price);
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
      className="priceRangeModal"
    >
      <div className="modalCrossBtn" onClick={onHide}>
        <ImCross />
      </div>
      <Modal.Header closeButton={false} className="priceModalHeader">
        <Modal.Title className="">
          Select Price Range
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="priceModalBody">
        <div className="priceRangeContainer row">
          {priceRanges.map((price) => (
            <button
              key={price.value}
              className="priceRangeItem "
              onClick={() => handlePriceSelect(price)}
            >
              {price.label}
            </button>
          ))}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PriceRangeModal;
